import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Directive({
    selector: '[authGroup]',
    standalone: false
})
export class AuthGroupDirective {

  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private _auth: AuthService) { }

  @Input() set authGroup(groups: Array<string>) {
    // Always clear first: the input can update on every navigation (e.g. new roles array
    // reference from authenticateUser) while access stays true; without clear(), embedded
    // views accumulate and duplicate the template (e.g. entire side nav repeated).
    this._viewContainer.clear();
    if (this.hasAccess(groups)) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    }
  }

  hasAccess(groups: Array<string>): boolean {
    let roles = this._auth.getRoles();
    for (let x = 0; x < roles.length; x++) {
      if (groups.indexOf(roles[x]) > -1) {
        return true;
      }
    }
    return false;
  }
}
